export enum ButtonIcons {
	StatusChange = 'iconfinder_ic_done_48px_3669355.svg',
	EtaChange = 'Group 140.svg',
	AddDocument = '1.svg',
	Comment = 'iconfinder_signature_4177631.svg',
	People = '79-users.svg',
	RequestUpdate = 'Fill.svg',
	Exit = 'iconfinder_logout_close_sign_out_exit_access_3994382.svg',
	Add = 'iconfinder_add_134224.svg',
	Submit = 'iconfinder_checked-2_309094.svg',
	Save = 'iconfinder_save_1608823.svg',
	Cancel = 'iconfinder_minus_6351965.svg',
	Delete = 'iconfinder_ic_delete_forever_48px_3669360.svg',
	Send = 'iconfinder_mail_email_send_message_2716894.svg',
	MultipleDocuments = 'multiple-documents.svg',
	Next = 'chevron_right-24px.svg',
	Link = 'link_black_24dp.svg',
	Edit = 'edit_black_24dp.svg',
	AddPhoto = 'add-photo-camera.svg',
	SaveAs = 'iconfinder-down_arrow_icon.svg',
}
